module.exports = __webpack_public_path__ + "static/img/rank_room_bg.6292241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_room_bg.png
// module id = tCDu
// module chunks = 0